@if (isVisible) {
  <div id="confirmDialog" class="confirmation-dialog-backdrop">
    <div class="confirmation-dialog-container" [class.danger-mode]="dangerMode">
      <div class="confirmation-dialog-header">
        <h2 class="confirmation-dialog-title">{{ title }}</h2>
      </div>
      <div class="confirmation-dialog-body">
        <p [innerHTML]="message"></p>
      </div>
      <div class="confirmation-dialog-footer">
        <button
          id="confirmDialogCancelButton"
          type="button"
          class="btn btn-white"
          (click)="close()"
          >
          <i class="fa fa-times" aria-hidden="true"></i>
          <span>{{ cancelButtonText }}</span>
        </button>
        <button
          id="confirmDialogConfirmButton"
          type="button"
          class="btn m-l"
          [ngClass]="confirmButtonClass"
          (click)="confirm()"
          >
          <i class="fa fa-copy" aria-hidden="true"></i>
          <span>{{ confirmButtonText }}</span>
        </button>
      </div>
    </div>
  </div>
}
